import * as React from 'react'
import { memo } from 'react'
const SvgPlane = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="1em"
    height="1em"
    viewBox="0 0 16 14.257"
  >
    <path d="M1.54 14.257v-.87h13.93v.87Zm1.155-4.285L0 5.472l1.269-.331 2.32 1.979 3.6-.939L2.903.427l1.62-.423 6.188 5.244 3.716-.984a1.2 1.2 0 0 1 .948.138 1.2 1.2 0 0 1 .582.762 1.3 1.3 0 0 1-.1.948 1.1 1.1 0 0 1-.729.582Z" />
  </svg>
)
const Memo = memo(SvgPlane)
export default Memo
